











import Vue from 'vue'
import PhrasesReportStore from '@/store/searchV3Report/phrases'
import store from '@/store'
import BarStatistics from '@/views/components/search/BarStatistics.vue'

export default Vue.extend({
  components: { BarStatistics },
  computed: {
    chartData() {
      return PhrasesReportStore.state.popularPhrasesData.data
    },
    start() {
      return (store.state as any).search.dateRange.start
    },
    dataLoading() {
      return PhrasesReportStore.state.popularPhrasesData.dataLoading
    },
  },
  watch: {
    start() {
      PhrasesReportStore.dispatch('getPopularPhrases')
    },
  },
  mounted() {
    PhrasesReportStore.dispatch('getPopularPhrases')
  },
  methods: {},
})
